import {getPrivateAxios} from '../../libs';
import {CollectionShare} from './types';

interface CollectionShareUpdateDto extends CollectionShare {
  collectionId: string;
}

export const fetchCollectionShareUpdate = async (updateDto: CollectionShareUpdateDto) => {
  const {data} = await getPrivateAxios().patch<CollectionShareUpdateDto>(
    `/collections/${updateDto.collectionId}/share`,
    {
      type: updateDto.type,
    },
  );
  return data;
};
